import {defineComponent} from "vue"

export default defineComponent({
  methods: {
    file_icon(file: App.Models.File): string {
      const icons = import.meta.glob('@/images/file-photos/*.svg', {
        eager: true,
        import: 'default',
      })

      const extension = this.convert(file.name.split('.').pop() || '')
      const key = `/resources/images/file-photos/${extension}.svg`

      return icons[key] as string
    },
    convert(type: string) {
      switch (type.toLowerCase()) {
        case 'docx':
        case 'doc':
          return 'doc'
        case 'mov':
        case 'avi':
        case 'wmv':
        case 'flv':
        case 'mkv':
        case 'webm':
        case 'mpeg':
        case 'mpg':
        case '3gp':
        case 'm4v':
        case 'mp4':
          return 'mp4'
        case 'csv':
        case 'xlsx':
        case 'xls':
          return 'xls'
        case 'png':
        case 'jpeg':
        case 'jpg':
        case 'gif':
        case 'bmp':
        case 'webp':
        case 'svg':
          return 'jpg'
        case 'pdf':
          return 'pdf'
        case 'txt':
          return 'txt'
        case 'zip':
        case 'rar':
        case '7z':
        case 'tar':
        case 'gz':
          return 'zip'
        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'aac':
        case 'flac':
          return 'mp3'
        default:
          return type
      }
    },
  }
})
